import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import queryString from 'query-string';
import Button from '@components/@core/AnimatedButton';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Search from '@components/@core/Search';
import VendorSearchBlogs from '@components/VendorSearchBlogs';
import VendorSearchCompanies from '@components/VendorSearchCompanies';
import VendorSearchForums from '@components/VendorSearchForums';
import VendorSearchPeople from '@components/VendorSearchPeople';
import VendorSearchProducts from '@components/VendorSearchProducts';
import VendorActions from '~/actions/vendor';
import { InitialGlobalSearchResult } from '~/services/config';
import withNavigate from '~/hocs/withNavigate';

const tabs = [
    { name: 'all', label: 'All' },
    { name: 'people', label: 'People' },
    { name: 'companies', label: 'Companies' },
    { name: 'products', label: 'Products' },
    // { name: 'training', label: 'Training' },
    { name: 'blogs', label: 'Blogs' },
    { name: 'forums', label: 'Forums' },
];

class VendorSearch extends Component {
    constructor(props) {
        super(props);
        const search = props.location?.search || '';
        this.state = {
            search: props.searchParam || '',
            tab: queryString.parse(search)?.active || 'all',
        };
    }

    componentDidMount() {
        this.handleSearch();
        if (this.props.searchParam) {
            this.setState({ search: this.props.searchParam });
            this.props.globalSearch({ search: this.props.searchParam }, this.state.tab);
        }
    }

    handleChangeSearch = (e) => {
        const search = e.target.value;
        this.setState({ search });
    };

    handleSearch = () => {
        const { search, tab } = this.state;
        const { searchResult } = this.props;
        const route = {
            pathname: '/vendor-ratings/search',
            param: { search: search || searchResult?.search },
        };

        this.props.globalSearch({ search: search || searchResult?.search }, tab);
        this.props.navigate(route);
    };

    handleSearchKeyDown = (e) => {
        if (e.key === 'Enter' && this.state.search !== '') {
            this.handleSearch();
        }
    };

    handleChangeTab = (tab) => {
        this.props.navigate({ search: `?active=${tab}` });
        this.setState({ tab }, () => this.handleSearch());
    };

    handleChangePage = (page) => {
        const { search, tab } = this.state;
        this.props.globalSearch({ search, page }, tab);
    };

    render() {
        const { tab, search } = this.state;
        const { searchResult } = this.props;

        return (
            <ErrorBoundary className="vendor-rating-search">
                <div className="vendor-rating-search-input mb-2">
                    <p className="dsl-b20 bold">Search</p>
                    <div className="d-h-start mb-3">
                        <Search className="search-input" initial={search || searchResult?.search} onChange={this.handleChangeSearch} onKeyDown={this.handleSearchKeyDown} />
                        <Button type="medium" name="SEARCH" onClick={this.handleSearch} />
                    </div>
                    <Tabs className="search-tabs" defaultActiveKey="all" activeKey={tab} id="global-search" onSelect={this.handleChangeTab}>
                        {tabs.map((tab) => (
                            <Tab key={tab.name} eventKey={tab.name} title={tab.label} />
                        ))}
                    </Tabs>
                </div>
                {tab === 'all' ? (
                    <Row className="mx-0 d-flex ssm-column">
                        <Col xs={12} sm={8} className="vendor-rating-search-results">
                            <p className="dsl-b20 bold">Search Results</p>
                            <VendorSearchPeople data={searchResult.users} onSeeAll={() => this.handleChangeTab('people')} />
                            <VendorSearchProducts data={searchResult.products} onSeeAll={() => this.handleChangeTab('products')} />
                            {/* <VendorSearchTraining
                authors={authors}
                data={[...searchResult.tracks, ...searchResult.courses, ...searchResult.modules]}
                onSeeAll={() => this.handleChangeTab('training')}
              /> */}
                            <VendorSearchBlogs data={searchResult.blogs} onSeeAll={() => this.handleChangeTab('blogs')} />
                            <VendorSearchForums data={searchResult.forums} onSeeAll={() => this.handleChangeTab('forums')} />
                        </Col>
                        <Col xs={12} sm={4} className="pr-0 ps-2">
                            <div className="vendor-rating-search-companies">
                                <VendorSearchCompanies data={searchResult.companies} onSeeAll={() => this.handleChangeTab('companies')} />
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <div className="vendor-rating-search-results">
                        {tab === 'people' && <VendorSearchPeople data={searchResult.users} type="full" />}
                        {tab === 'companies' && <VendorSearchCompanies data={searchResult.companies} type="full" onPage={this.handleChangePage} />}
                        {tab === 'products' && <VendorSearchProducts data={searchResult.products} type="full" onPage={this.handleChangePage} />}
                        {/* hide training tab until we support it by global search */}
                        {/* {tab === 'training' && (
              <VendorSearchTraining
                authors={authors}
                data={[...searchResult.tracks, ...searchResult.courses, ...searchResult.modules]}
                type="full"
              />
            )} */}
                        {tab === 'blogs' && <VendorSearchBlogs data={searchResult.blogs} type="full" onPage={this.handleChangePage} />}
                        {tab === 'forums' && <VendorSearchForums data={searchResult.forums} type="full" onPage={this.handleChangePage} />}
                    </div>
                )}
            </ErrorBoundary>
        );
    }
}

VendorSearch.propTypes = {
    authors: PropTypes.array,
    searchResult: PropTypes.any,
};

VendorSearch.defaultProps = {
    authors: [],
    searchResult: InitialGlobalSearchResult,
};

const mapStateToProps = (state) => ({
    userId: state.app.id,
    authors: state.app.authors,
    searchResult: state.vendor.globalSearchResult,
});

const mapDispatchToProps = (dispatch) => ({
    globalSearch: (payload, target) => dispatch(VendorActions.globalsearchRequest(payload, null, null, null, target)),
});

const VendorSearchWithNavigate = withNavigate(VendorSearch);

export default connect(mapStateToProps, mapDispatchToProps)(VendorSearchWithNavigate);
